<template>
  <base-modal hide-footer hide-header @close="$emit('close')" size="lg">
      <h3 class="editor-header">{{ modelValue.otsikko }}</h3>
      <div class="editor-form form-data" @click.stop="">
        <div class="row">
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('common.id') }}</span>
            <span class="item-detail-text">{{ format(modelValue.ilmoitusid) }}</span>
          </div>
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('harja.notification_type') }}</span>
            <span class="item-detail-text">{{ format(modelValue.ilmoitustyyppi) }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('notification_list.topic') }}</span>
            <span class="item-detail-text">{{ modelValue.aihe.nimi }} - {{ modelValue.aihe.id }}</span>
          </div>
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('street_lights.pole_additional_info') }}</span>
            <span class="item-detail-text">{{ modelValue.tarkenne.nimi }} - {{ modelValue.tarkenne.id }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('harja.forwarded_harja') }}</span>
            <span class="item-detail-text">{{ format(getDate(modelValue.valitettyH)) }}</span>
          </div>
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('harja.forwarded_inspection') }}</span>
            <span class="item-detail-text">{{ format(getDate(modelValue.valitettyUrakkaan)) }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('harja.notified') }}</span>
            <span class="item-detail-text">{{ format(getDate(modelValue.ilmoitettu)) }}</span>
          </div>
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('harja.received_harja') }}</span>
            <span class="item-detail-text">{{ format(getDate(modelValue.vastaanotettuHarjaan)) }}</span>
          </div>
        </div>


        <div class="row">
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('harja.sender') }}</span>
            <span class="item-detail-text"> {{ format(modelValue.lahettaja.etunimi) + ' ' + format(modelValue.lahettaja.sukunimi) + ' ' + format(modelValue.lahettaja.email) }}</span>
          </div>
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('defects.reporter') }}</span>
            <span class="item-detail-text">{{ format(modelValue.ilmoittaja.etunimi) + ' ' + format(modelValue.ilmoittaja.sukunimi) + ' ' + format(modelValue.ilmoittaja.email) + ' ' + format(modelValue.ilmoittaja.matkapuhelin) }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('harja.notification_type') }}</span>
            <span class="item-detail-text">{{ format(modelValue.ilmoitustyyppi) }}</span>
          </div>
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('material_station.scale_id') }}</span>
            <span class="item-detail-text">{{ format(modelValue.tunniste) }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('contracts.status') }}</span>
            <span class="item-detail-text">{{ format(modelValue.tila) }}</span>
          </div>
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('equipment.description') }}</span>
            <span class="item-detail-text">{{ format(modelValue.lisatieto) }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('harja.site_description') }}</span>
            <span class="item-detail-text">{{ format(modelValue.paikankuvaus) }}</span>
          </div>
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('harja.area_inspection_number') }}</span>
            <span class="item-detail-text">{{ format(modelValue.alueurakkanumero) }}</span>
          </div>
        </div>

        <div class="my-2">
          <vue3-datatable
              ref="resultTable"
              :rows="modelValue.selitteet"
              :columns="tableFields"
              :pagination="false"
              :sticky-header="true"
              height="100%"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
          />
        </div>
        <div v-if="results.length > 0" class="my-2">
          <vue3-datatable
              ref="resultTable"
              :rows="results"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="100%"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
          />
        </div>
        <div class="col-12 d-flex justify-content-end">
          <button class="btn btn-secondary form-button" @click.stop="$emit('cancel')">
            <span>{{ $t('common.close') }}</span>
          </button>
        </div>
      </div>
  </base-modal>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import BaseModal from "@/components/BaseModal";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: "HarjaNotificationModal",
    components: {BaseModal, Vue3Datatable},
    mixins: [restApi, timeUtils],
    props: {
        modelValue: {
            type: Object,
            return: null
        },
        isObserver: {
            type: Boolean,
            default: false
        },
        isWorker: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            tableFields: [],
            fields: [],
            results: [],
            harjaData: []
        }
    },

    mounted() {
        this.initTableItems()
        this.tableFields = [
            {field: 'selite', title: this.$t('road_details.definition'), sort: false}
        ]
        this.fields = [
            { field: 'kuittaustyyppi', title: this.$t('harja.acknowledgement_type'), sort: true},
            { field: 'kuitattu', title: this.$t('harja.acknowledgement'), sort: true},
            { field: 'ytunnus', title: this.$t('harja.business_id'), sort: true},
            { field: 'fullname', title: this.$t('common.name'), sort: true},
            { field: 'vakiofraasi', title: this.$t('harja.stantard_question'), sort: false},
            { field: 'vapaateksti', title: this.$t('harja.free_text'), sort: false}
        ]
    },

    methods: {

        initTableItems: function () {
            this.results = []
            const temp = []
            this.modelValue.kuittaukset.forEach(item => {
                temp.push({
                    kuittaustyyppi: this.format(item.kuittaus.kuittaustyyppi, ' '),
                    kuitattu: this.format(this.getDate(item.kuittaus.kuitattu), ''),
                    ytunnus: this.format(item.kuittaus.kuittaajaorganisaatio.ytunnus, ' '),
                    fullname: this.format(item.kuittaus.kuittaaja.etunimi) + ' ' + this.format(item.kuittaus.kuittaaja.sukunimi),
                    vakiofraasi: this.format(item.kuittaus.vakiofraasi, ' '),
                    vapaateksti: this.format(item.kuittaus.vapaateksti, ' '),
                })
            })
            this.$nextTick(() => this.results = temp)
        },

        format(message, fallBackText) {
            if (!message || message === '' || message === '[]') {
                if (!fallBackText) {
                    fallBackText = '-'
                }
                return fallBackText
            }
            return message
        },

    }
}
</script>
